import { injectIntl } from 'react-intl';
import ConfigureThresholds from './ConfigureThresholds';
import { withEnabledFeatures } from '../../utils/features';

export default injectIntl(withEnabledFeatures(ConfigureThresholds));
